module.exports = __webpack_public_path__ + "img/logo-STAIKA.5f10a702.svg";